import AssistantInboxesAPI from 'dashboard/api/assistant/inboxes';
import { createStore } from '../storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

export default createStore({
  name: 'AssistantInbox',
  API: AssistantInboxesAPI,
  actions: mutations => ({
    delete: async function remove({ commit, state }, { inboxId, agentId }) {
      commit(mutations.SET_UI_FLAG, { deletingItem: true });
      try {
        await AssistantInboxesAPI.delete({ inboxId, agentId });
        // Records are agent-inbox joins, remove by the nested inbox id
        const records = state.records.filter(
          record => record.inbox?.id !== inboxId
        );
        commit(mutations.SET, records);
        commit(mutations.SET_UI_FLAG, { deletingItem: false });
        return inboxId;
      } catch (error) {
        commit(mutations.SET_UI_FLAG, { deletingItem: false });
        return throwErrorMessage(error);
      }
    },
  }),
});
